import { TimePeriod } from '@candu-ai/analytics/types';

export const getMomentPeriodFormat = (period: TimePeriod) => {
  if (period === TimePeriod.Minutes || period === TimePeriod.Hours) {
    return 'HH:mm';
  }
  return 'L';
};
